function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min); // The maximum is inclusive and the minimum is inclusive
  }

// Shuffles the elements in the array and returns the shuffled values
function shuffleArray(array) {

  let MAX_ATTEMPTS = 1000;

  let shuffledArray = [];
  let numbersToShuffle = array.length;
  let arrayPreShuffle = [];
  let i = 0;
  
  for (i = 0; i < array.length; i++) {
      arrayPreShuffle[i] = blkTypes[i];
  }

  while (numbersToShuffle != 0 || MAX_ATTEMPTS < 0) {

    i = getRandomInt(0, array.length);

    if (array[i] != null) {
      shuffledArray.push(i);
      array[i] = null;
      numbersToShuffle--;
    }


    MAX_ATTEMPTS--;

  }
  console.log("array shuffled!\noriginally: " + array + "\nshuffled: " + shuffledArray);

  return shuffledArray
}



  export {getRandomInt, shuffleArray}